import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/oneteg-new-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-9cb93a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-bg" }, null, -1))
const _hoisted_2 = { class: "newPassword" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-section height-10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_4 = { class: "d-flex justify-content-center align-content-center flex-column height-90" }
const _hoisted_5 = {
  style: {"margin-left":"145px"},
  class: "passwordValidation",
  id: "passwordValidation"
}
const _hoisted_6 = {
  style: {"margin-left":"145px"},
  id: "shortPassword",
  class: "passwordValidation"
}
const _hoisted_7 = {
  style: {"margin-left":"145px"},
  id: "includeDigit",
  class: "passwordValidation"
}
const _hoisted_8 = {
  style: {"margin-left":"145px"},
  id: "includeSpecialChar",
  class: "passwordValidation"
}
const _hoisted_9 = {
  style: {"margin-left":"145px"},
  id: "includeUpperCase",
  class: "passwordValidation"
}
const _hoisted_10 = {
  style: {"margin-left":"145px"},
  id: "includeLowerCase",
  class: "passwordValidation"
}
const _hoisted_11 = {
  style: {"margin-left":"145px"},
  id: "includeWhitespace",
  class: "passwordValidation"
}
const _hoisted_12 = {
  style: {"margin-left":"145px"},
  id: "longPassword",
  class: "passwordValidation"
}

import { onMounted, ref, watch, watchEffect } from "vue";
import { ElButton, ElForm, ElFormItem, ElInput } from "element-plus";
import passwordMeter from "vue-simple-password-meter";
import i18n from "@/core/i18n/i18n";
import { router, currentRoute } from "@/core/router";
import { changeLocale } from "@/core/i18n";
import { isUserLoggedIn } from "@/core/auth";
import { newPassword } from "@/user/services/user.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewPassword',
  setup(__props) {

const { t } = i18n.global;

const shortPassword = ref("");
const includeDigit = ref("");
const includeSpecialChar = ref("");
const includeUpperCase = ref("");
const includeLowerCase = ref("");
const includeWhitespace = ref("");
const longPassword = ref("");

const passwordValidation = ref("");

const loading = ref(false);

const formUser = ref({
  newPassword: "",
  password: "",
});

const formRules = ref({
  newPassword: {
    required: true,
    message: t("Auth.PasswordNotMatched"),
    trigger: "blur",
  },
  password: {
    required: true,
    message: t("Auth.PasswordVal"),
    trigger: "blur",
  },
});

function matchPassword() {
  let valid = false;
  if (formUser.value.password === formUser.value.newPassword) {
    document.getElementById("passwordValidation").style.color = "green";
    passwordValidation.value = "Password Matched";
    if (TestPassword(formUser.value.password)) {
      valid = true;
    }
  } else {
    document.getElementById("passwordValidation").style.color = "red";
    passwordValidation.value = "Password does not Match";
  }
  validValue.value = valid;
  return valid;
}

function containsSpecialChars(str) {
  const specialChars = /[!@#$%^&*()_+~`\-=[\]{};':"\\|,.<>/?]/;
  return specialChars.test(str);
}

function containsUpperCaseChars(str) {
  return /[A-Z]/.test(str);
}

function containsLowerCaseChars(str) {
  return /[a-z]/.test(str);
}

function containsNumber(str) {
  return /\d/.test(str);
}
function updateValidationStatus(elementId, updatedVariable, isValid, message) {
  document.getElementById(elementId).style.color = isValid ? "green" : "red";
  updatedVariable.value = message;
}

function setValidationMessageAndStatus(elementId, updatedVariable, message) {
  document.getElementById(elementId).style.color = "green";
  updatedVariable.value = message;
}

function validatePassword() {
  const password = ref();
  let valid = false;
  password.value = formUser.value.password;
  if (TestPassword(password.value)) {
    setValidationMessageAndStatus(
      "shortPassword",
      shortPassword,
      t("Auth.ShortPassword")
    );
    setValidationMessageAndStatus(
      "includeSpecialChar",
      includeSpecialChar,
      t("Auth.IncludeSpecialChar")
    );
    setValidationMessageAndStatus(
      "includeUpperCase",
      includeUpperCase,
      t("Auth.IncludeUpperCase")
    );
    setValidationMessageAndStatus(
      "includeLowerCase",
      includeLowerCase,
      t("Auth.IncludeLowerCase")
    );
    setValidationMessageAndStatus(
      "includeDigit",
      includeDigit,
      t("Auth.IncludeDigit")
    );
    includeWhitespace.value = "";
    longPassword.value = "";
    valid = true;
  } else {
    updateValidationStatus(
      "shortPassword",
      shortPassword,
      password.value.length >= 8,
      t("Auth.ShortPassword")
    );
    updateValidationStatus(
      "includeSpecialChar",
      includeSpecialChar,
      containsSpecialChars(password.value),
      t("Auth.IncludeSpecialChar")
    );
    updateValidationStatus(
      "includeUpperCase",
      includeUpperCase,
      containsUpperCaseChars(password.value),
      t("Auth.IncludeUpperCase")
    );
    updateValidationStatus(
      "includeLowerCase",
      includeLowerCase,
      containsLowerCaseChars(password.value),
      t("Auth.IncludeLowerCase")
    );
    updateValidationStatus(
      "includeDigit",
      includeDigit,
      containsNumber(password.value),
      t("Auth.IncludeDigit")
    );
    if (password.value.includes(" ")) {
      updateValidationStatus(
        "includeWhitespace",
        includeWhitespace,
        false,
        t("Auth.WhitespaceNotAllowed")
      );
    } else {
      updateValidationStatus("includeWhitespace", includeWhitespace, true, "");
    }
    if (password.value.length > 64) {
      updateValidationStatus(
        "longPassword",
        longPassword,
        false,
        t("Auth.LongPassword")
      );
    } else {
      updateValidationStatus("longPassword", longPassword, true, "");
    }
  }
  validValue.value = valid;
}

function TestPassword(value) {
  const strongRegex = new RegExp(
    "^(?!.*(\\d)\\1{2})(?!.*[\\s])(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+~`\\-=\\[\\]{};':\"\\\\|,.<>\\/?]).{8,64}$"
  );
  return strongRegex.test(value);
}

const validValue = ref(false);

const elForm = ref<InstanceType<typeof ElForm>>();

onMounted(() => {
  if (isUserLoggedIn.value) {
    router.push("/");
  }

  watch(
    () => [formUser.value.password, formUser.value.newPassword],
    () => {
      elForm.value.validate((valid) => {
        validValue.value = valid;
      });
    }
  );
});
const backToLogin = () => {
  router.push("/login");
};

async function addNewPassword() {
  loading.value = true;

  const activationId = currentRoute.value.params.id as string;
  if (validValue.value && activationId) {
    const result = await newPassword(activationId, formUser.value.password);
    if (result) {
      await router.push("/login");
    }
  }
  loading.value = false;
}

const selectedLocale = ref(currentRoute.value.params.locale as string);
watchEffect(() => changeLocale(selectedLocale.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(ElForm), {
          ref_key: "elForm",
          ref: elForm,
          model: formUser.value,
          rules: formRules.value,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElFormItem), {
              class: "d-flex flex-column align-items-center justify-content-center",
              prop: "password",
              "status-icon": "true",
              label: _unref(t)('Common.Password')
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  modelValue: formUser.value.password,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formUser.value.password) = $event)),
                  class: "min-width",
                  onKeyup: _cache[1] || (_cache[1] = ($event: any) => (validatePassword(), matchPassword())),
                  id: "newPassword",
                  placeholder: _unref(t)('Common.NewPassword'),
                  "show-password": "",
                  type: "password"
                }, null, 8, ["modelValue", "placeholder"]),
                _createVNode(_unref(passwordMeter), {
                  password: formUser.value.password
                }, null, 8, ["password"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(passwordValidation.value), 1),
            _createVNode(_unref(ElFormItem), {
              class: "d-flex flex-column align-items-center justify-content-center",
              prop: "password",
              "status-icon": "true",
              label: _unref(t)('Common.ReEnterPassword')
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  modelValue: formUser.value.newPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formUser.value.newPassword) = $event)),
                  class: "min-width",
                  placeholder: _unref(t)('Common.ConfirmPassword'),
                  onKeyup: _cache[3] || (_cache[3] = ($event: any) => (matchPassword())),
                  "show-password": "",
                  id: "confirm_password",
                  type: "password"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(shortPassword.value), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(includeDigit.value), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(includeSpecialChar.value), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(includeUpperCase.value), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(includeLowerCase.value), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(includeWhitespace.value), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(longPassword.value), 1),
            _createVNode(_unref(ElFormItem), { class: "d-flex justify-content-center align-content-center flex-column flex-wrap" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  disabled: !validValue.value,
                  loading: loading.value,
                  class: "btn-primary confirm-button",
                  "native-type": "submit",
                  onClick: _withModifiers(addNewPassword, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Confirm ")
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            }),
            _createElementVNode("span", {
              class: "forgotPasswordText",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (backToLogin()))
            }, _toDisplayString(_unref(t)("Auth.BackLogin")), 1)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 64))
}
}

})